export default __webpack_public_path__ + "static/media/Solo.2be7f142.webp";